import { render, staticRenderFns } from "./AdminFilterAmount.vue?vue&type=template&id=2acab996&scoped=true"
import script from "./AdminFilterAmount.vue?vue&type=script&lang=js"
export * from "./AdminFilterAmount.vue?vue&type=script&lang=js"
import style0 from "./AdminFilterAmount.vue?vue&type=style&index=0&id=2acab996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acab996",
  null
  
)

export default component.exports